const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { DogGame } = require('./DogBreedGame.blop');
let { getNewDog } = require('./services.blop');

function DogPage(attributes, _children, node) {let __2;
  let { state } = attributes;
  node.mount(async () => {
    if ((!state.dogPage.choice)) {
      await getNewDog(state);
    }
  });

  const __1c = []; const __1a = {}; __1a['page'] = state.dogPage; __1a['state'] = state; __1a['loading'] = state.loading;
    __2 = 'Dog breed game'; Array.isArray(__2) ? __1c.push(...__2) : __1c.push(__2); ;
   const __1 = blop.c(DogGame, __1a, __1c, '__1'); return __1;
};
module.exports = { DogGame, getNewDog, DogPage };
